export default "__VITE_ASSET__YdEirir8__"